<template>
    <div class="input">
        <v-select :clearable="clearable" :components="{ OpenIndicator }" class="input__select" :options="options"
            @input="$emit('input', $event)" :label="label" :value="value" :searchable="false" :disabled="disabled" />
    </div>
</template>

<script>
import VSelect from 'vue-select'
export default {
    components: {
        VSelect,
    },
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            required: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        value: {
            type: [Object, Number, String],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            OpenIndicator: {
                render: (createElement) =>
                    createElement('div', {
                        class: {
                            toggle: true,
                            fas: true,
                            'fa-caret-down': true,
                        },
                    }),
            },
        }
    },
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';

.input {
    border-radius: 4px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(55, 71, 79, 0.2);
    height: 40px;
    min-height: 40px;

    &__select {
        height: 100%;

        .vs__dropdown-toggle {
            border: none;
            height: 100%;
        }
    }

    .vs__selected {
        height: 100%;
        color: $greyish-brown;
    }
}

.toggle {
    margin-right: 5px;
    font-size: 18px;
    color: #4a4a4a;
}
</style>
